export const SET_METADATAS = "setMetadatas";
export const SET_TOTAL_METADATAS = "setTotalMetadatas";
export const CLEAR_METADATAS = "clearMetadatas";
export const CLEAR_TOTAL_METADATAS = "clearTotalMetadatas";
export const SET_METADATA = "setMetadata";
export const CLEAR_METADATA = "clearMetadata";
export const SET_METADATA_FIELD = "setMetadataField";
